/**
 * The browser loads the signed-in user once at startup (src/index.js). The page's own data
 * for the visitor (src/Routes.js, loadClientData) waits for it, so it reads the right user
 * instead of fetching it a second time. Browser only: the server never sets it.
 */
let loaded = Promise.resolve();

export const setCurrentUserLoaded = promise => {
  loaded = Promise.resolve(promise).catch(() => null);
};

export const currentUserLoaded = () => loaded;
